// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "worklog-worker" + "." + "1e9e9f3a919ad1c1494b" + ".js";
};